<template>
  <div>
    <div v-if="loading" class="text-center">
      <LoadingIndicator dir="ltr" :loading="loading" :clz="clz" />
    </div>
    <slot v-if="!loading" />
  </div>
</template>
<script>
import LoadingIndicator from '@/components/LoadingIndicator.vue'
export default {
  components: {
    LoadingIndicator
  },
  props: {
    loading: Boolean,
    clz: String
  }
};
</script>
